module.exports = require("./dist/lodash.compat.js");


//////////////////
// WEBPACK FOOTER
// lodash (bower component)
// module id = 1034
// module chunks = 1